/* Zoci info pages (About, Contact, FAQ, policies). Each part runs only when its markup is on the page. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Toast: one polite live region for the whole page */
  var toast, toastTimer;
  function say(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'zp__toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="m3.5 8.5 3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    toast.appendChild(document.createTextNode(msg));
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (ok, fail) {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy') ? ok() : fail(); } catch (e) { fail(e); }
      t.remove();
    });
  }

  /* 1. One-click copy */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-zp-copy]');
    if (!b) return;
    var v = b.getAttribute('data-zp-copy');
    copy(v).then(function () {
      b.classList.add('is-done');
      setTimeout(function () { b.classList.remove('is-done'); }, 1600);
      say(b.getAttribute('data-zp-said') || 'Copied ' + v);
    }, function () { say('Press and hold to copy'); });
  });

  /* 2. Open now / closed: studio hours in India time, whatever the visitor's clock says */
  $$('[data-zp-hours]').forEach(function (el) {
    var open = +el.dataset.from, close = +el.dataset.to;
    var days = (el.dataset.days || '1,2,3,4,5').split(',').map(Number);
    var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    function fmt(h) { var s = h >= 12 ? 'pm' : 'am', x = h % 12 || 12; return x + ' ' + s; }
    function update() {
      var parts = {};
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false })
          .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      } catch (e) { return; }
      var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
      var h = +parts.hour % 24 + (+parts.minute) / 60;
      var isOpen = days.indexOf(day) > -1 && h >= open && h < close;
      var text;
      if (isOpen) {
        var left = close - h;
        text = '<b>Open now</b> · ' + (left <= 1 ? 'closes at ' + fmt(close) + ', soon' : 'until ' + fmt(close) + ' India time');
      } else {
        var d = day, add = 0;
        if (days.indexOf(day) > -1 && h < open) { add = 0; } else { do { d = (d + 1) % 7; add++; } while (days.indexOf(d) < 0 && add < 8); }
        var when = add === 0 ? 'today' : add === 1 ? 'tomorrow' : names[d];
        text = '<b>Closed now</b> · opens ' + when + ' at ' + fmt(open) + '. Leave a message, we reply then.';
      }
      el.setAttribute('data-open', isOpen ? 'true' : 'false');
      var t = el.querySelector('[data-zp-hours-text]');
      if (t) t.innerHTML = text;
      el.hidden = false;
    }
    update();
    setInterval(update, 60000);
  });

  /* 3. Contact: a topic fills in the WhatsApp message and the form at once */
  var topics = $('[data-zct-topics]');
  if (topics) {
    var waLinks = $$('[data-zct-wa]');
    var msg = $('#ContactForm-body');
    var orderField = $('[data-zct-order]');
    var orderInput = orderField && orderField.querySelector('input');
    var topicInput = $('[data-zct-topic-input]');
    var lastPrefill = '';
    function pick(btn) {
      $$('[data-topic]', topics).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var wantsOrder = btn.dataset.order === 'true';
      if (orderField) orderField.hidden = !wantsOrder;
      if (topicInput) topicInput.value = btn.dataset.label;
      var waText = btn.dataset.wa + (wantsOrder && orderInput && orderInput.value ? ' ' + orderInput.value : '');
      waLinks.forEach(function (a) { a.href = 'https://wa.me/' + a.dataset.zctWa + '?text=' + encodeURIComponent(waText); });
      if (msg && (msg.value === '' || msg.value === lastPrefill)) { msg.value = btn.dataset.prefill; lastPrefill = msg.value; }
    }
    topics.addEventListener('click', function (e) {
      var b = e.target.closest('[data-topic]');
      if (!b) return;
      pick(b);
      if (msg && window.matchMedia('(min-width: 850px)').matches) { msg.focus(); msg.setSelectionRange(msg.value.length, msg.value.length); }
    });
    if (orderInput) orderInput.addEventListener('input', function () {
      var on = $('[data-topic][aria-pressed="true"]', topics);
      if (on) pick(on);
    });
    var pre = location.hash.match(/topic=([a-z-]+)/);
    var first = pre ? $('[data-topic="' + pre[1] + '"]', topics) : null;
    if (first) pick(first);
  }

  /* 4. Contact form: say what is missing before the round trip */
  var form = $('[data-zct-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      var bad = null;
      $$('[required]', form).forEach(function (f) {
        var ok = f.value.trim() !== '' && (f.type !== 'email' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.value.trim()));
        f.setAttribute('aria-invalid', ok ? 'false' : 'true');
        var err = document.getElementById(f.id + '-err');
        if (err) err.hidden = ok;
        if (!ok && !bad) bad = f;
      });
      if (bad) { e.preventDefault(); bad.focus(); return; }
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.querySelector('span').textContent = 'Sending'; }
    });
    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.value.trim()) {
        e.target.setAttribute('aria-invalid', 'false');
        var err = document.getElementById(e.target.id + '-err');
        if (err) err.hidden = true;
      }
    });
  }

  /* 5. FAQ: search as you type, topic nav that follows the scroll, links to single answers */
  var faq = $('[data-zfq]');
  if (faq) {
    var input = $('[data-zfq-search]');
    var clear = $('[data-zfq-clear]');
    var kbd = $('.zfq__kbd');
    var count = $('[data-zfq-count]');
    var empty = $('[data-zfq-empty]');
    var emptyQ = $('[data-zfq-empty-q]');
    var emptyWa = $('[data-zfq-empty-wa]');
    var groups = $$('[data-zfq-group]', faq);
    var qs = $$('.zfq__q', faq);
    var total = qs.length;
    var faqSpy = null;
    qs.forEach(function (q) {
      var s = q.querySelector('summary .zfq__qt');
      q._q = s.textContent; q._sEl = s;
      q._text = (q.textContent || '').toLowerCase().replace(/\s+/g, ' ');
    });
    function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function mark(el, raw, words) {
      if (!words.length) { el.textContent = raw; return; }
      var re = new RegExp('(' + words.map(esc).join('|') + ')', 'gi');
      el.innerHTML = raw.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }).replace(re, '<mark class="zfq__hit">$1</mark>');
    }
    function run() {
      var v = input.value.trim().toLowerCase();
      var words = v.split(/\s+/).filter(function (w) { return w.length > 1; });
      var shown = 0;
      qs.forEach(function (q) {
        var hit = !words.length || words.every(function (w) { return q._text.indexOf(w) > -1; });
        q.hidden = !hit;
        if (hit) shown++;
        mark(q._sEl, q._q, words);
      });
      groups.forEach(function (g) {
        var any = $$('.zfq__q', g).some(function (q) { return !q.hidden; });
        g.hidden = !any;
        var link = $('[data-zfq-nav="' + g.id + '"]');
        if (link) link.parentElement.hidden = !any;
        $$('[data-zfq-chip="' + g.id + '"]').forEach(function (c) { c.parentElement.hidden = !any; });
      });
      if (clear) clear.hidden = !v;
      if (kbd) kbd.hidden = !!v;
      count.textContent = v ? (shown ? shown + (shown === 1 ? ' answer' : ' answers') + ' for "' + input.value.trim() + '"' : '') : total + ' answers in ' + groups.length + ' topics';
      empty.hidden = shown > 0;
      if (!shown) {
        emptyQ.textContent = input.value.trim();
        emptyWa.href = 'https://wa.me/' + emptyWa.dataset.wa + '?text=' + encodeURIComponent('Hi ZOCI, I have a question: ' + input.value.trim());
      }
      if (v && shown && shown <= 3) qs.forEach(function (q) { if (!q.hidden) q.open = true; });
      if (faqSpy) faqSpy();
    }
    var t;
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 80); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; run(); } });
    if (clear) clear.addEventListener('click', function () { input.value = ''; run(); input.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); input.focus(); }
    });
    run();

    /* Open the answer a link points at */
    function openHash() {
      var id = decodeURIComponent(location.hash.slice(1));
      var q = id && document.getElementById(id);
      if (q && q.classList.contains('zfq__q')) { q.open = true; setTimeout(function () { q.scrollIntoView({ block: 'start' }); }, 30); }
    }
    openHash();
    window.addEventListener('hashchange', openHash);

    faq.addEventListener('click', function (e) {
      var b = e.target.closest('[data-zfq-permalink]');
      if (!b) return;
      var url = location.origin + location.pathname + '#' + b.dataset.zfqPermalink;
      copy(url).then(function () { say('Link to this answer copied'); }, function () {});
      history.replaceState(null, '', '#' + b.dataset.zfqPermalink);
    });

    faqSpy = spy($$('[data-zfq-nav]'), function (a) { return document.getElementById(a.dataset.zfqNav); });
  }

  /* 6. Policy: contents follow the scroll; print */
  var toc = $('[data-zpo-toc]');
  if (toc) {
    var mq = window.matchMedia('(min-width: 850px)');
    var sync = function () { if (mq.matches) toc.open = true; };
    sync();
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    toc.querySelector('summary').addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    $$('a', toc).forEach(function (a) { a.addEventListener('click', function () { if (!mq.matches) toc.open = false; }); });
    spy($$('a', toc), function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  }
  $$('[data-zp-print]').forEach(function (b) { b.addEventListener('click', function () { window.print(); }); });

  /* Scroll-spy: the last section whose top has passed a line 30% down the screen; the first one before that */
  function spy(links, target) {
    var pairs = links.map(function (a) { return [a, target(a)]; }).filter(function (p) { return p[1]; });
    if (!pairs.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      var line = window.innerHeight * 0.3, cur = null;
      pairs.forEach(function (p) { if (!p[1].hidden && p[1].getBoundingClientRect().top <= line) cur = p; });
      if (!cur) cur = pairs.filter(function (p) { return !p[1].hidden; })[0];
      pairs.forEach(function (p) { p === cur ? p[0].setAttribute('aria-current', 'true') : p[0].removeAttribute('aria-current'); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    return update;
  }
})();
